import { render, staticRenderFns } from "./Fanpai.vue?vue&type=template&id=7a1f54a5&"
import script from "./Fanpai.vue?vue&type=script&lang=js&"
export * from "./Fanpai.vue?vue&type=script&lang=js&"
import style0 from "./Fanpai.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports